// extracted by mini-css-extract-plugin
export default {"headerStyle":"styles_headerStyle__ppZ6Y","textStyle":"styles_textStyle__1rrdp"};